import differenceBy from "lodash/differenceBy";
import omit from "lodash/omit";

import {
  ADD_GLOBAL_ADMIN_FAILED,
  ADD_GLOBAL_ADMIN_START,
  ADD_GLOBAL_ADMIN_SUCCESS,
  ADD_POLICY,
  COMMIT_ADD_POLICIES_SUCCESS,
  COMMIT_DELETE_POLICIES_SUCCESS,
  COMMIT_POLICIES_FAILED,
  COMMIT_POLICIES_START,
  FETCH_POLICIES_FAILED,
  FETCH_POLICIES_START,
  FETCH_POLICIES_SUCCESS,
  MARK_POLICY_CLEAN,
  MARK_POLICY_FOR_DELETE,
  MARK_POLICY_FOR_UPDATE,
  REMOVE_DIRTY_POLICY,
  REMOVE_POLICY_CANCEL,
  REMOVE_POLICY_FAILED,
  REMOVE_POLICY_START} from "../constants";

const policiesDefaults = {
  loading: false,
  items: [],
  saving: false
};

const policiesReducer = (state = policiesDefaults, action) => {
  switch (action.type) {
    case FETCH_POLICIES_START:
      return {
        ...state,
        loading: true
      };
    case FETCH_POLICIES_SUCCESS: {
      // Filter dirty policies
      const items = state.items.filter(
        item => !item.requiresUpdate && !item.requiresDelete
      );
      const newState = {
        ...state,
        items: [...items, ...differenceBy(action.json, items, "$uri")],
        loading: false
      };
      return newState;
    }
    case FETCH_POLICIES_FAILED:
      return {
        ...state,
        errorDescription: action.error.description,
        error: action.error.message,
        loading: false
      };
    case ADD_POLICY:
      return {
        ...state,
        items: [
          ...state.items,
          {
            ...action.policy,
            requiresUpdate: true
          }
        ]
      };
    case REMOVE_POLICY_START:
      if (action.policy.$uri) {
        return {
          ...state,
          items: state.items.filter(
            policy => policy.$uri !== action.policy.$uri
          )
        };
      }
      return state;
    case REMOVE_POLICY_CANCEL:
      return {
        ...state,
        items: [...state.items, action.policy]
      };
    case REMOVE_POLICY_FAILED:
      return {
        ...state,
        items: [...state.items, action.policy],
        errorDescription: action.error.description,
        error: action.error.message
      };
    case REMOVE_DIRTY_POLICY:
      if (action.policy.id) {
        return {
          ...state,
          items: state.items.filter(policy => policy.id !== action.policy.id)
        };
      }
      return state;
    case MARK_POLICY_FOR_UPDATE:
      return {
        ...state,
        items: state.items.map(policy => {
          if (
            (action.policy.$uri && action.policy.$uri === policy.$uri) ||
            (action.policy.id && action.policy.id === policy.id)
          ) {
            return {
              ...policy,
              requiresUpdate: true,
              requiresDelete: false
            };
          }
          return policy;
        })
      };
    case MARK_POLICY_FOR_DELETE:
      if (action.policy.$uri) {
        return {
          ...state,
          items: state.items.map(policy => {
            if (action.policy.$uri === policy.$uri) {
              return {
                ...policy,
                requiresUpdate: false,
                requiresDelete: true
              };
            }
            return policy;
          })
        };
      }
      return state;
    case MARK_POLICY_CLEAN:
      return {
        ...state,
        items: state.items.map(policy => {
          if (
            (action.policy.$uri && action.policy.$uri === policy.$uri) ||
            (action.policy.id && action.policy.id === policy.id)
          ) {
            return {
              ...policy,
              requiresUpdate: false,
              requiresDelete: false
            };
          }
          return policy;
        })
      };
    case COMMIT_POLICIES_START:
      return {
        ...state,
        saving: true
      };
    case COMMIT_ADD_POLICIES_SUCCESS:
      return omit(
        {
          ...state,
          saving: false
        },
        ["errorDescription", "error"]
      );
    case COMMIT_DELETE_POLICIES_SUCCESS:
      return omit(
        {
          ...state,
          saving: false,
          items: differenceBy(state.items, action.policies, "$uri")
        },
        ["errorDescription", "error"]
      );
    case COMMIT_POLICIES_FAILED:
      return {
        ...state,
        errorDescription: action.error.description,
        error: action.error.message,
        saving: false
      };
    case ADD_GLOBAL_ADMIN_START:
      return {
        ...state,
        saving: true
      };
    case ADD_GLOBAL_ADMIN_SUCCESS:
      return omit(
        {
          ...state,
          saving: false
        },
        ["errorDescription", "error"]
      );
    case ADD_GLOBAL_ADMIN_FAILED:
      return {
        ...state,
        errorDescription: action.error.description,
        error: action.error.message,
        saving: false
      };
    default:
      return state;
  }
};

export default policiesReducer;
